import data from "../../data/index.json";
import { motion } from "motion/react";

const headingVariants = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
};

const gridVariants = {
  hidden: {},
  show: { transition: { staggerChildren: 0.12 } },
};

const cardVariants = {
  hidden: { opacity: 0, y: 32 },
  show: { opacity: 1, y: 0, transition: { duration: 0.55, ease: "easeOut" } },
};

const viewportConfig = { once: true, amount: 0.15 };

export default function MyPortfolio() {
  return (
    <section className="portfolio--section" id="MyPortfolio">
      <div className="portfolio--container-box">
        <motion.div
          className="portfolio--container"
          variants={headingVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
        >
          <h2 className="section--heading">My Portfolio</h2>
        </motion.div>
      </div>
      <motion.div
        className="portfolio--section--container"
        variants={gridVariants}
        initial="hidden"
        whileInView="show"
        viewport={viewportConfig}
      >
        {data?.portfolio?.map((item, index) => (
          <motion.div
            key={index}
            className="portfolio--section--card"
            variants={cardVariants}
            whileHover={{ y: -6, transition: { duration: 0.2 } }}
          >
            <div className="portfolio--section--card--content">
              <div>
                <h3 className="portfolio--section--title">{item.title}</h3>
                <p className="text-md">{item.description}</p>
              </div>
            </div>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
}
